import React from 'react';
import { useLocation } from 'react-router-dom';
import { Box } from '@material-ui/core';
import { Hidden } from '€components/Hidden';
import ContentLayout from '€layouts/ContentLayout';
import { PageLayoutProps } from '€layouts/PageLayout/PageLayout';
import PageLayout from '€layouts/PageLayout';
import TopLevelNavigation from '€components/TopLevelNavigation';
import ContentFooter from '€layouts/ContentFooter';
import { PostAuthLayoutWidth, TopAppBarHeight } from '€lib/layout';
import { Routes } from '../../lib/routing';

type PostAuthContentLayout = {
    children: React.ReactNode;
};

export const PostAuthContentLayout: React.FC<PostAuthContentLayout> = ({ children }) => {
    const { pathname } = useLocation();

    return (
        <ContentLayout pb={{ xs: TopAppBarHeight, sm: 0 }}>
            <Box display="flex">
                <Box>
                    <Box
                        flex={1}
                        pb={{ md: 4, xs: 4 }}
                        maxWidth={{ xs: '100vw', md: PostAuthLayoutWidth }}
                        display="flex"
                        flexDirection="column"
                        px={{ xs: 3, md: 7 }}
                    >
                        {children}
                    </Box>
                </Box>
            </Box>
        </ContentLayout>
    );
};

const PostAuthLayout = (props: PageLayoutProps) => {
    return (
        <>
            <Hidden xsDown>
                <PageLayout contentComponent={PostAuthContentLayout} {...props} />
            </Hidden>
            <Hidden smUp>
                <PageLayout
                    contentComponent={PostAuthContentLayout}
                    footerComponent={TopLevelNavigation}
                    {...props}
                />
            </Hidden>
        </>
    );
};

export default PostAuthLayout;
